import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Button from '@mui/material/Button';
import { RESUME_EVALUATION_ROUTER_PATH } from '@/constants/router-path';
import { trackClickEvent } from '@/utils/site-track';
import ResumeEvaluationImage from '@/assets/seo/resume-evaluation.png';

const GeneralSection = (props: {
  children: React.ReactNode;
  marginTop?: string;
  showRight?: boolean;
  resumeEvaluationTitle?: string;
  rightComponent?: React.ReactNode;
}) => {
  const {
    children,
    marginTop = 'mt-0',
    showRight = true,
    resumeEvaluationTitle = '你的简历真能打动 HR 吗？',
    rightComponent,
  } = props;
  if (!showRight) return <>{children}</>;
  return (
    <div className={`flex gap-x-10 ${marginTop}`}>
      <div className="grow">{children}</div>
      <div className="w-[300px] shrink-0">
        <div
          className="bg-web-purple-100 rounded-lg px-6 pb-6 pt-1 text-center"
          data-observer-id="marketing_right-banner_evaluation"
          data-ele-group="marketing_banner_evaluation"
          data-ele-id={resumeEvaluationTitle}
        >
          <div className="relative h-65">
            <Image
              src={ResumeEvaluationImage}
              alt=""
              fill
              style={{
                objectFit: 'contain',
              }}
            />
          </div>
          <p className="font-semibold mb-2">{resumeEvaluationTitle}</p>
          <p className="text-sm text-web-grey-600 pb-4 mb-3.5 border-b border-b-web-tertiary">
            专业诊断，帮你找出不足，提升面试通过率
          </p>
          <Button
            variant="contained"
            className="!w-[220px] !h-[42px] !bg-white !text-primary hover:!bg-web-neutral-300"
            LinkComponent={Link}
            href={RESUME_EVALUATION_ROUTER_PATH}
            onClick={trackClickEvent}
          >
            立即诊断简历
          </Button>
        </div>
        {rightComponent}
      </div>
    </div>
  );
};

export default GeneralSection;
